// Module
var code = `<template> <div class="onboardingplugins-navbar row justify-content-end padding-5"> <custom-button class="custom-button-create-dynamic-client-form-plugin" click.delegate="createDynamicOnboardingPlugin()">Create Dynamic Client Form Plugin</custom-button> </div> </template> `;
// Exports
module.exports = code;